// ICT Devices theme script. Helpers are added per feature.

// Pre-fill quote forms from ?part= and ?qty= (values only, never HTML).
document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(location.search);
  for (const key of ['part', 'qty']) {
    const value = params.get(key);
    if (!value) continue;
    document.querySelectorAll(`[data-ict-prefill="${key}"]`).forEach((el) => { el.value = value; });
  }
});

// Collection filters start open on desktop, closed on mobile.
document.addEventListener('DOMContentLoaded', () => {
  if (!matchMedia('(min-width: 990px)').matches) return;
  document.querySelectorAll('[data-ict-open-desktop]').forEach((el) => { el.open = true; });
});

// Close mega-menu keyboard trap: Escape returns focus to the page.
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const mega = document.activeElement && document.activeElement.closest('.ict-mega');
  if (mega) document.activeElement.blur();
});

// Product gallery: thumbnails swap the main image.
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('[data-ict-thumb]');
  const main = document.getElementById('ict-main-image');
  if (!thumb || !main) return;
  e.preventDefault();
  main.removeAttribute('srcset');
  main.src = thumb.getAttribute('href');
});

// Sticky header: scroll the util bar and logo row away, keep only the menu row pinned.
(() => {
  const section = document.querySelector('.ict-header-section');
  const nav = section && section.querySelector('.ict-nav');
  if (!section || !nav) return;
  const measure = () => {
    const offset = nav.offsetParent ? nav.getBoundingClientRect().top - section.getBoundingClientRect().top : 0;
    section.style.setProperty('--ict-hdr-collapse', `${Math.max(0, Math.round(offset))}px`);
  };
  measure();
  new ResizeObserver(measure).observe(section);
})();
